module.exports = __webpack_public_path__ + "assets/headspace_logo@3x-69e0f1eeec1690fa47511beed74bee45.png";